import { render } from "./Send.vue?vue&type=template&id=5f81bd30&scoped=true"
import script from "./Send.vue?vue&type=script&lang=js"
export * from "./Send.vue?vue&type=script&lang=js"

import "@/assets/css/dne-pay.css?vue&type=style&index=0&id=5f81bd30&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f81bd30"]])

export default __exports__